import React, { useEffect } from "react";

export function useObserver(
  ref: React.RefObject<HTMLElement | null>,
  onChange: (state: State) => void,
  options?: IntersectionObserverInit,
) {
  useEffect(() => {
    const { current } = ref;

    if (!current) {
      return;
    }

    const topObserver = new IntersectionObserver(([entry]) => {
      if (entry) {
        const state = getStateFromEntry(entry);

        onChange(state);
      }
    }, options);

    topObserver.observe(current);

    return () => {
      topObserver.unobserve(current);
    };
  }, []);
}

export type State = "visible" | "below" | "above";

export function getStateFromEntry(entry: IntersectionObserverEntry): State {
  if (entry.isIntersecting) {
    return "visible";
  }

  if (entry.boundingClientRect.top > 0) {
    return "below";
  } else {
    return "above";
  }
}
